import { FilterOptions } from '@aytm/app/insights/dashboard/lib/filters'
import { getPanelFilters } from '@aytm/app/insights/dashboard/helpers/filters'
import { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import { FiltersOrderedMap } from '@aytm/app/insights/dashboard/models/types.ClientModel'

export type StateSelectorParams = {
  filterOptions: FilterOptions | null
  panelModelFilters: FiltersOrderedMap | null
}

export const stateSelector = (state: InsightsDashboardPoolState): StateSelectorParams => {
  const filterOptions = state.currentData?.filterOptions || null
  const panelModelFilters = getPanelFilters(state)
  return {
    filterOptions,
    panelModelFilters
  }
}

export const shouldUpdate = (prev: StateSelectorParams, next: StateSelectorParams) =>
  !prev && !next
    ? false
    : prev.filterOptions !== next.filterOptions || prev.panelModelFilters !== next.panelModelFilters
